"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
var idm_de_service_client_js_1 = require("@synisys/idm-de-service-client-js");
var operators_1 = require("rxjs/operators");
var Subject_1 = require("rxjs/Subject");
var party_picker_settings_component_1 = require("./settings/party-picker-settings.component");
var zip_1 = require("rxjs/observable/zip");
var party_picker_provider_service_1 = require("../../shared/services/api/party-picker-provider.service");
var root_category_provider_service_1 = require("../../shared/services/api/root-category-provider.service");
var filtered_party_1 = require("./model/filtered-party");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var meta_knowledge_provider_service_1 = require("../../shared/services/api/meta-knowledge-provider.service");
var PartyPickerComponent = /** @class */ (function () {
    function PartyPickerComponent(partyPickerProviderService, rootCategoryProviderService, metaKnowledgeProviderService, deService) {
        this.partyPickerProviderService = partyPickerProviderService;
        this.rootCategoryProviderService = rootCategoryProviderService;
        this.metaKnowledgeProviderService = metaKnowledgeProviderService;
        this.deService = deService;
        this.availableParties = [];
        this.selectedParties = [];
        this.isReady = false;
        this._destroy$ = new Subject_1.Subject();
    }
    PartyPickerComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.entity) {
            if (this.isReadonly) {
                this.rootCategoryProviderService.getRootCategoryId(this.category).pipe(operators_1.switchMap(function (rootCategoryId) { return _this.metaKnowledgeProviderService.getPartyDefinitions(rootCategoryId); }), operators_1.takeUntil(this._destroy$)).subscribe(function (partyDefinitions) {
                    _this.partyDefinitions = partyDefinitions;
                    _this.checkForSelectedParties([]);
                    if (!_this.selectedParties.length && _this.selectedParty) {
                        _this.selectedParties = [_this.selectedParty];
                    }
                    _this.isReady = true;
                });
            }
            else {
                this._fieldCategory = this.subEntityField['compoundCategorySystemName'];
                this._fieldId = this.subEntityField['metaFieldId']['systemName'];
                var rootEntity$ = this.rootCategoryProviderService.getRootEntity(this.category, this.entity);
                var dummySubEntity$ = this.deService.createBlankSubEntity(this._fieldCategory);
                var partyDefinitions$ = this.rootCategoryProviderService.getRootCategoryId(this.category).pipe(operators_1.switchMap(function (rootCategoryId) { return _this.metaKnowledgeProviderService.getPartyDefinitions(rootCategoryId); }));
                zip_1.zip(rootEntity$, partyDefinitions$, dummySubEntity$).pipe(operators_1.switchMap(function (_a) {
                    var rootEntity = _a[0], partyDefinitions = _a[1], blankSubEntity = _a[2];
                    _this.partyDefinitions = partyDefinitions;
                    _this._blankSubEntity = blankSubEntity;
                    return _this.partyPickerProviderService.provide(_this.filterConfigs, rootEntity, _this.partyDefinitions);
                }), operators_1.takeUntil(this._destroy$))
                    .subscribe(function (parties) {
                    _this.checkForSelectedParties(parties);
                    _this.availableParties = parties;
                    _this.isReady = true;
                });
            }
        }
    };
    PartyPickerComponent.prototype.ngOnDestroy = function () {
        this._destroy$.next(true);
        this._destroy$.complete();
    };
    PartyPickerComponent.prototype.setSelectedOption = function (party) {
        this.selectedParty = party;
        if (party) {
            this.entity.getProperty(this._fieldId).value = [this.getNewPartySubEntity(party)];
        }
        else {
            this.entity.getProperty(this._fieldId).value = [];
        }
    };
    PartyPickerComponent.prototype.setSelectedOptions = function (parties) {
        var _this = this;
        this.selectedParties = parties;
        if (parties.length) {
            this.entity.getProperty(this._fieldId).value = parties.map(function (party) { return _this.getNewPartySubEntity(party); });
        }
        else {
            this.entity.getProperty(this._fieldId).value = [];
        }
    };
    PartyPickerComponent.prototype.checkForSelectedParties = function (parties) {
        var _this = this;
        this.partySubEntities.forEach(function (subEntity) {
            var selectedParty = subEntity.getProperty(_this.subEntityPartyField).value;
            var selectedPartyRole = _this.subEntityRoleField && subEntity.getProperty(_this.subEntityRoleField).value;
            var availableParty = parties.find(function (party) {
                return party.id === selectedParty.getInstanceId() && ((!selectedPartyRole && !party.role) || (selectedPartyRole && party.role && selectedPartyRole.getId() === party.role.getId()));
            });
            if (availableParty) {
                _this.isMultiSelect || _this.isReadonly ? _this.selectedParties.push(availableParty) : _this.selectedParty = availableParty;
            }
            else {
                var deletedParty = new filtered_party_1.FilteredParty(selectedParty.getInstanceId(), selectedParty, selectedPartyRole);
                parties.push(deletedParty);
                _this.isMultiSelect || _this.isReadonly ? _this.selectedParties.push(deletedParty) : _this.selectedParty = deletedParty;
            }
        });
        if (!this.isReadonly) {
            this.isMultiSelect ? this.setSelectedOptions(this.selectedParties) : this.setSelectedOption(this.selectedParty);
        }
    };
    PartyPickerComponent.prototype.getNewPartySubEntity = function (party) {
        var newPartySubEntity = this._blankSubEntity.clone();
        newPartySubEntity.getProperty('parentId').value = this.entity.getId();
        newPartySubEntity.getProperty(this.subEntityPartyField).value = party.entity;
        if (this.subEntityRoleField) {
            newPartySubEntity.getProperty(this.subEntityRoleField).value = party.role;
        }
        return newPartySubEntity;
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", idm_de_service_client_js_1.MainEntity)
    ], PartyPickerComponent.prototype, "entity", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], PartyPickerComponent.prototype, "partySubEntities", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", idm_kb_service_client_js_1.MetaField)
    ], PartyPickerComponent.prototype, "subEntityField", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], PartyPickerComponent.prototype, "category", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], PartyPickerComponent.prototype, "isReadonly", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], PartyPickerComponent.prototype, "currentLanguageId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], PartyPickerComponent.prototype, "filterConfigs", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], PartyPickerComponent.prototype, "isMultiSelect", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], PartyPickerComponent.prototype, "subEntityPartyField", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], PartyPickerComponent.prototype, "subEntityRoleField", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], PartyPickerComponent.prototype, "configured", void 0);
    PartyPickerComponent = __decorate([
        core_1.Component({
            
            selector: 'ejustice-party-picker',
            template: require('./party-picker.component.html'),
        }),
        idm_dynamic_controls_metadata_1.ControlMetadata({
            cellCount: 6,
            name: 'Party Picker',
            settings: {
                main: party_picker_settings_component_1.PartyPickerSettingsComponent,
            },
            template: "<ejustice-party-picker\n                    [entity]=\"entity\"\n                    [category]=\"category\"\n                    [isReadonly]=\"%{isReadonly}\"\n                    [currentLanguageId]=\"currentLanguageId\"\n                    [partySubEntities]=\"%{field}\"\n                    [subEntityField]=\"%{subEntityField}\"\n                    [filterConfigs]=\"%{filterConfigs}\"\n                    [isMultiSelect]=\"%{isMultiSelect}\"\n                    [subEntityPartyField]=\"%{subEntityPartyField}\"\n                    [subEntityRoleField]=\"%{subEntityRoleField}\"\n                    [configured]=\"%{configured}\">\n                </ejustice-party-picker>"
        }),
        __metadata("design:paramtypes", [party_picker_provider_service_1.PartyPickerProviderService,
            root_category_provider_service_1.RootCategoryProviderService,
            meta_knowledge_provider_service_1.MetaKnowledgeProviderService,
            idm_de_service_client_js_1.DeService])
    ], PartyPickerComponent);
    return PartyPickerComponent;
}());
exports.PartyPickerComponent = PartyPickerComponent;
//# sourceMappingURL=party-picker.component.js.map